import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            漫画分类
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            八大分类，精准找到你喜欢的韩国漫画类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 md:p-6 flex flex-col items-center gap-3 transition-all duration-300 hover:bg-primary-50 border border-background-200/70 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-primary-200 group-hover:text-primary-700 transition-colors duration-300">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <div className="text-center">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{cat.count}部漫画</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}